<template>
    <div class="card p-3 h-100" v-if="this.entity">
      <h2>Details</h2>
      <hr class="mt-3 mb-3">
      
      <div class="row">
        <div class="col-6">
          <base-input label="Organisation Name" :value="entity.name" readonly />
        </div>
        <div class="col-6">
          <base-input label="ID" :value="entity.id" readonly />
        </div>
      </div>

      <div class="row">
        <div class="col-12">
          <base-input label="Address" :value="combinedAddress" readonly />
        </div>
      </div>

      <div class="row">
        <div class="col-6">
          <base-input label="City" :value="entity.address_city" readonly />
        </div>
        <div class="col-6">
          <base-input label="Postcode" :value="entity.address_postcode" readonly />
        </div>
      </div>

      <div class="row">
        <div class="col-12">
          <base-input label="Description">
            <textarea class="form-control" rows="3" v-model="entity.description" readonly></textarea>
          </base-input>
        </div>
      </div>

      <div class="row" v-if="entity && entity.dropInstructions">
        <div class="col-12">
          <base-input label="Drop Instructions">
            <textarea class="form-control" rows="3" v-model="entity.dropInstructions" readonly></textarea>
          </base-input>
        </div>
      </div>
    </div>
</template>

<script>
 
  export default {
    name: 'details-card',
    components: {
     
    },

    props:[
      'entity'
    ],

    data() {
      return {
       
      };
    },

    computed:{
      combinedAddress: function() {
        if(this.entity) {
          let addresses = [this.entity.address_line_1];
          
          if(this.entity.address_line_2) {
            addresses.push(this.entity.address_line_2);
          }
          
          return addresses.join(', ');
        }

        return null;
      }
    },

    methods: {
       
    },

    watch:{
        
    }
  }
</script>